import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

export interface CommerceUserPreferences {
  currency: string | null
  measurement_system: string | null
  locale: string | null
  adult_content: string | null
  country: string | null
}

export interface CommerceUser {
  pricing_cohort: string | null
  trade: boolean
  order_id_pending: number | null
  preferences: CommerceUserPreferences
}

export const useCommerceKey = ['useCommerce']

export default function useCommerce(options = {}) {
  return useQuery<CommerceUser>(
    useCommerceKey,
    async () => {
      const response = await axios.get<CommerceUser>(
        '/api/spoonflower/user/commerce',
        { withCredentials: true }
      )
      return response.data
    },
    options
  )
}
